import React from "react";
import "./Terms.css";

function Terms() {
  return (
    <div className="terms-wrapper">
      <div className="terms-container">
        <h1>Terms of Use</h1>
<p>Last Updated: January 2026</p>

<h2>1. Acceptance of Terms</h2>
<p>
  By accessing or using EmployPilot (“the Platform”), you agree to comply
  with these Terms of Use. If you do not agree, you may not use the Platform.
</p>

<h2>2. Description of Service</h2>
<p>
  EmployPilot provides AI-powered tools such as resume builders, career
  insights, interview practice, and community discussions. Features may
  evolve or change over time.
</p>

<h2>3. User Accounts</h2>
<p>
  You are responsible for maintaining the confidentiality of your account.
  You agree not to share login credentials, create fraudulent profiles, or
  impersonate others.
</p>

<h2>4. Community Use & User Content</h2>
<p>
  You may post content in the community area. By posting, you grant
  EmployPilot a non-exclusive license to display the content within the app.
  You agree that posted content:
</p>
<ul>
  <li>Must not violate any laws or harm other users</li>
  <li>Must not include confidential or personal information of others</li>
  <li>Must not contain harassment, threats, or hate speech</li>
</ul>
<p>
  EmployPilot reserves the right to remove or moderate content that violates
  these guidelines.
</p>

<h2>5. Intellectual Property</h2>
<p>
  All branding, features, designs, and AI-generated material are the exclusive
  property of EmployPilot. Users may not copy, distribute, or resell platform
  assets without permission.
</p>

<h2>6. Subscription & Payments</h2>
<p>
  EmployPilot Pro is a paid subscription. By subscribing, you authorize
  EmployPilot (via Stripe or in-app purchase) to charge your payment method.
</p>

<h2>7. Cancellation</h2>
<p>
  Users may cancel at any time. Access continues until the end of the current
  billing cycle. No prorated refunds are provided.

  For subscriptions purchased through Apple, payment and cancellation are managed through the user’s Apple ID settings.
</p>

<h2>8. Disclaimer of Warranties</h2>
<p>
  EmployPilot is provided “as is.” We do not guarantee employment outcomes,
  accuracy of AI-generated information, or uninterrupted access.
</p>

<h2>9. Limitation of Liability</h2>
<p>
  EmployPilot is not liable for decisions based on generated content,
  community interactions, or third-party service issues.
</p>

<h2>10. Account Termination</h2>
<p>
  We reserve the right to suspend or terminate accounts that violate these
  terms or harm the platform or community.
</p>

<h2>11. Changes to Terms</h2>
<p>
  These Terms may be updated periodically. Continued use of the Platform
  constitutes acceptance of revised terms.
</p>

<h2>12. Contact Us</h2>
<p>
  For questions or concerns:<br />
  <strong>support@employpilot.com</strong>
</p>

<footer className="terms-footer">© 2025 EmployPilot. All Rights Reserved.</footer>

      </div>
    </div>
  );
}

export default Terms;
